// Mock data for Teqvis Technologies website

export const services = [
  {
    id: 1,
    title: "Custom Software Development",
    icon: "Code",
    description: "Tailored software solutions designed specifically for your business needs",
    features: [
      "Billing & Invoicing Systems",
      "ERP Solutions",
      "CRM Systems",
      "Clinic Management Systems",
      "School & Institute Management",
      "Business Automation Tools"
    ]
  },
  {
    id: 2,
    title: "Web Design & Development",
    icon: "Globe",
    description: "Modern, responsive websites that drive business growth",
    features: [
      "Business Websites",
      "Portfolio Websites",
      "CMS Websites",
      "SaaS Platforms",
      "Web Portals"
    ]
  },
  {
    id: 3,
    title: "Mobile App Development",
    icon: "Smartphone",
    description: "Native and cross-platform mobile applications",
    features: [
      "Android Applications",
      "Flutter Applications",
      "Business Apps",
      "Internal Enterprise Apps"
    ]
  },
  {
    id: 4,
    title: "Cloud & IT Services",
    icon: "Cloud",
    description: "Scalable cloud solutions and infrastructure management",
    features: [
      "Cloud Server Setup (AWS/Azure)",
      "Cloud Migration",
      "Server Maintenance & Backup",
      "DevOps & Deployment Support"
    ]
  },
  {
    id: 5,
    title: "IT Support & AMC",
    icon: "Settings",
    description: "Reliable technical support and maintenance contracts",
    features: [
      "Annual Maintenance Contracts",
      "Bug Fixing & Updates",
      "Performance Monitoring",
      "Technical Support"
    ]
  },
  {
    id: 6,
    title: "Digital Marketing Services",
    icon: "TrendingUp",
    description: "Boost your online presence and reach more customers",
    features: [
      "SEO Optimization",
      "Google Ads & PPC",
      "Social Media Marketing",
      "Content Strategy",
      "Email Marketing",
      "Analytics & Reporting"
    ]
  },
  {
    id: 7,
    title: "Technical Consultation",
    icon: "Terminal",
    description: "Expert technical guidance to build scalable and secure systems",
    features: [
      "System Architecture Design",
      "Technology Stack Selection",
      "Code Reviews & Audits",
      "Scalability Planning",
      "Database Optimization"
    ]
  },
  {
    id: 8,
    title: "UI/UX Design",
    icon: "Palette",
    description: "Creating intuitive and engaging user experiences",
    features: [
      "User Research & Testing",
      "Wireframing & Prototyping",
      "Mobile & Web Design",
      "Brand Identity Design",
      "Interaction Design"
    ]
  },
  {
    id: 9,
    title: "Data Analytics & AI",
    icon: "Brain",
    description: "Transforming data into actionable insights with AI",
    features: [
      "Business Intelligence Dashboards",
      "Predictive Analytics",
      "Machine Learning Solutions",
      "Data Warehousing",
      "Process Automation"
    ]
  }
];

export const industries = [
  { 
    name: "Small & Medium Businesses", 
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1497215728101-856f4ea42174?auto=format&fit=crop&q=80"
  },
  { 
    name: "Clinics & Healthcare", 
    icon: "Heart",
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?auto=format&fit=crop&q=80"
  },
  { 
    name: "Schools & Educational Institutions", 
    icon: "GraduationCap",
    image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&q=80&w=800"
  },
  { 
    name: "Retail & Trading Companies", 
    icon: "ShoppingCart",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80"
  },
  { 
    name: "Startups", 
    icon: "Rocket",
    image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&q=80"
  },
  { 
    name: "Service Providers", 
    icon: "Users",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80"
  },
  { 
    name: "Manufacturing", 
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80"
  },
  { 
    name: "Logistics", 
    icon: "Truck",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&q=80"
  },
  { 
    name: "Real Estate", 
    icon: "Building",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&q=80"
  },
  { 
    name: "Hospitality", 
    image: "https://images.unsplash.com/photo-1566073771259-6a8506099945?auto=format&fit=crop&q=80"
  },
  { 
    name: "Travel & Tourism", 
    icon: "Plane",
    image: "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&q=80"
  },
  { 
    name: "Automotive", 
    icon: "Car",
    image: "https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?auto=format&fit=crop&q=80"
  },
  { 
    name: "Construction", 
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80"
  },
  { 
    name: "Media & Entertainment", 
    icon: "Clapperboard",
    image: "https://images.unsplash.com/photo-1603739903239-8b6e64c3b185?auto=format&fit=crop&q=80"
  },
  {
    name: "Finance & Fintech",
    icon: "Banknote",
    image: "https://images.unsplash.com/photo-1563986768494-4dee2763ff3f?auto=format&fit=crop&q=80"
  }
];

export const workProcess = [
  { step: 1, title: "Requirement Discussion", description: "Understanding your business needs and challenges" },
  { step: 2, title: "Solution Planning", description: "Designing the optimal solution for your requirements" },
  { step: 3, title: "Proposal & Approval", description: "Clear proposal with timeline and pricing" },
  { step: 4, title: "Development", description: "Building your solution with regular updates" },
  { step: 5, title: "Testing & Delivery", description: "Thorough testing before final deployment" },
  { step: 6, title: "Support & Maintenance", description: "Ongoing support and updates" }
];

export const whyChooseUs = [
  { title: "Transparent Pricing", description: "No hidden costs, clear quotations", icon: "DollarSign" },
  { title: "Clear Timelines", description: "Realistic deadlines we stick to", icon: "Clock" },
  { title: "Dedicated Support", description: "Always available when you need us", icon: "HeadphonesIcon" },
  { title: "Scalable Solutions", description: "Grows with your business", icon: "TrendingUp" },
  { title: "Long-term Partnership", description: "We're here for the long run", icon: "Handshake" },
  { title: "Quality Assured", description: "Rigorous testing and quality checks", icon: "CheckCircle" }
];

export const testimonials = [
  {
    id: 1,
    name: "Business Owner",
    company: "Trading Business",
    location: "Kerala",
    text: "Teqvis Technologies provided a reliable software solution for our business. The system is easy to use and their support is very responsive.",
    rating: 5
  },
  {
    id: 2,
    name: "Clinic Administrator",
    company: "Private Clinic",
    location: "Kerala",
    text: "Good communication and timely delivery. The team understood our requirements clearly and delivered as promised.",
    rating: 5
  },
  {
    id: 3,
    name: "Startup Founder",
    company: "Tech Startup",
    location: "India",
    text: "Professional approach and cost-effective solution. We are happy with the long-term support provided.",
    rating: 5
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Custom Billing & ERP System",
    category: "Custom Software",
    clientType: "Local Trading Business",
    description: "Developed a custom billing and ERP system to manage invoices, inventory, customers, and reports.",
    features: [
      "Billing & invoicing",
      "Inventory management",
      "GST reports",
      "User roles"
    ],
    result: "Reduced manual work and improved reporting accuracy",
    technologies: [],
    image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d"
  },
  {
    id: 2,
    title: "Clinic Management Software",
    category: "Healthcare Solution",
    clientType: "Private Clinic",
    description: "Built a clinic management system to manage patients, appointments, billing, and reports.",
    features: [
      "Patient records",
      "Appointment scheduling",
      "Billing & reports",
      "Secure access"
    ],
    result: "Faster operations and better patient management",
    technologies: ["Node.js"],
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d"
  },
  {
    id: 3,
    title: "Business Website & Lead System",
    category: "Web Development",
    clientType: "Service Company",
    description: "Designed and developed a professional website with inquiry and lead management.",
    features: [
      "Responsive website",
      "Contact & inquiry forms",
      "SEO-friendly pages",
      "Lead tracking"
    ],
    result: "Improved online presence and customer inquiries",
    technologies: ["FastAPI", "MongoDB"],
    image: "https://images.unsplash.com/photo-1557821552-17105176677c"
  },
  {
    id: 4,
    title: "E-commerce Website",
    category: "E-commerce",
    clientType: "Retail Business",
    description: "Created an e-commerce platform with product listing, orders, and payment integration.",
    features: [
      "Product catalog",
      "Order management",
      "Payment gateway",
      "Admin dashboard"
    ],
    result: "Online sales channel enabled",
    technologies: ["Node.js", "Stripe"],
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b"
  },
  {
    id: 5,
    title: "Food Delivery App",
    category: "Mobile App",
    clientType: "Food Startup",
    description: "Built a cross-platform mobile app for food ordering and delivery tracking.",
    features: [
      "Live tracking",
      "Push notifications",
      "Payment integration",
      "Driver app"
    ],
    result: "10k+ downloads in first month",
    technologies: ["Flutter", "Firebase", "Google Maps"],
    image: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?auto=format&fit=crop&q=80"
  },
  {
    id: 6,
    title: "Cloud Migration & DevOps",
    category: "Cloud Services",
    clientType: "FinTech Company",
    description: "Migrated legacy on-premise servers to AWS infrastructure with CI/CD pipelines.",
    features: [
      "Zero downtime migration",
      "Auto-scaling setup",
      "Docker containerization",
      "Automated backups"
    ],
    result: "40% reduction in server costs",
    technologies: ["AWS", "Docker", "Kubernetes"],
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa"
  }
];

// Form submission handlers (mock for now, will be replaced with backend APIs)
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Contact form submitted:", formData);
      resolve({ success: true, message: "Thank you for contacting us! We'll get back to you soon." });
    }, 1000);
  });
};

export const submitQuotationRequest = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Quotation request submitted:", formData);
      resolve({ success: true, message: "Quotation request received! Our team will contact you within 24 hours." });
    }, 1000);
  });
};

export const companyInfo = {
  name: "Teqvis Technologies LLP",
  tagline: "Innovative IT Solutions for Business Growth",
  description: "A technology services company specializing in custom software and IT solutions that help businesses improve efficiency, reduce manual work, and grow digitally.",
  email: "contact@teqvis.in",
  phone: "+91 7994260656",
  address: "Ramanattukara, Calicut, Kerala, India",
  whatsapp: "+917994260656",
  socialLinks: {
    linkedin: "#", // To be added later
    twitter: "#",
    facebook: "#"
  }
};

export const missionVision = {
  mission: "To empower businesses with innovative technology solutions that drive efficiency, growth, and digital transformation.",
  vision: "To be a globally recognized technology partner known for delivering excellence, integrity, and impactful digital experiences."
};

export const coreValues = [
  {
    title: "Innovation",
    description: "We constantly explore new technologies to deliver forward-thinking solutions.",
    icon: "Lightbulb"
  },
  {
    title: "Integrity",
    description: "We believe in honest, transparent, and ethical business practices.",
    icon: "ShieldCheck"
  },
  {
    title: "Excellence",
    description: "We are committed to delivering high-quality results in everything we do.",
    icon: "Award"
  },
  {
    title: "Client-Centric",
    description: "Your success is our priority. We work closely with you to achieve your goals.",
    icon: "Users"
  }
];

export const companyHistory = [
  {
    year: "2020",
    title: "The Beginning",
    description: "Founded with a vision to provide affordable yet premium IT solutions to local businesses."
  },
  {
    year: "2021",
    title: "Expansion",
    description: "Expanded our team and started serving clients across Kerala and neighboring states."
  },
  {
    year: "2022",
    title: "New Horizons",
    description: "Launched our cloud services and enterprise solution divisions."
  },
  {
    year: "2023",
    title: "Global Reach",
    description: "Started working with international clients and established a strong digital presence."
  },
  {
    year: "2024",
    title: "Innovation Hub",
    description: "Focusing on AI-driven solutions and next-gen web technologies."
  }
];

export const teamMembers = [
  {
    id: 1,
    name: "Alex Morgan",
    role: "CEO & Founder",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&q=80",
    bio: "Visionary leader with 10+ years in tech innovation."
  },
  {
    id: 2,
    name: "Sarah Chen",
    role: "Lead Developer",
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80",
    bio: "Full-stack expert passionate about scalable architecture."
  },
  {
    id: 3,
    name: "Michael Ross",
    role: "Creative Director",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?auto=format&fit=crop&q=80",
    bio: "Award-winning designer focusing on user-centric experiences."
  },
  {
    id: 4,
    name: "Priya Patel",
    role: "Project Manager",
    image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?auto=format&fit=crop&q=80",
    bio: "Ensuring timely delivery and client satisfaction."
  }
];

export const techStack = [
  {
    category: "Frontend",
    items: [
      { name: "React", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { name: "Next.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nextjs/nextjs-original.svg" },
      { name: "Angular", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" },
      { name: "Vue.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vuejs/vuejs-original.svg" },
      { name: "TypeScript", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg" },
      { name: "Tailwind CSS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tailwindcss/tailwindcss-original.svg" },
      { name: "HTML5", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/html5/html5-original.svg" }
    ]
  },
  {
    category: "Mobile",
    items: [
      { name: "Flutter", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/flutter/flutter-original.svg" },
      { name: "React Native", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" },
      { name: "Kotlin", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kotlin/kotlin-original.svg" },
      { name: "Swift", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/swift/swift-original.svg" }
    ]
  },
  {
    category: "Backend",
    items: [
      { name: "Python", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
      { name: "Django", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/django/django-plain.svg" },
      { name: "Node.js", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" },
      { name: "Express", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/express/express-original.svg" },
      { name: "Go", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/go/go-original-wordmark.svg" },
      { name: "Java", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" },
      { name: "Spring", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/spring/spring-original.svg" },
      { name: ".NET Core", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/dotnetcore/dotnetcore-original.svg" },
      { name: "C#", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/csharp/csharp-original.svg" },
      { name: "PHP", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/php/php-original.svg" },
      { name: "Laravel", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/laravel/laravel-original.svg" }
    ]
  },
  {
    category: "Database",
    items: [
      { name: "PostgreSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/postgresql/postgresql-original.svg" },
      { name: "MongoDB", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mongodb/mongodb-original.svg" },
      { name: "MySQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
      { name: "MSSQL", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/microsoftsqlserver/microsoftsqlserver-plain.svg" },
      { name: "Redis", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/redis/redis-original.svg" }
    ]
  },
  {
    category: "Cloud & DevOps",
    items: [
      { name: "Firebase", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/firebase/firebase-plain.svg" },
      { name: "AWS", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original-wordmark.svg" },
      { name: "Azure", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg" },
      { name: "Google Cloud", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg" },
      { name: "Docker", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
      { name: "Kubernetes", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg" },
      { name: "Jenkins", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg" }
    ]
  },
  {
    category: "Digital Marketing",
    items: [
      { name: "Google Ads", icon: "https://upload.wikimedia.org/wikipedia/commons/c/c7/Google_Ads_logo.svg" },
      { name: "Facebook", icon: "https://upload.wikimedia.org/wikipedia/commons/0/05/Facebook_Logo_%282019%29.png" },
      { name: "Instagram", icon: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Instagram_logo_2016.svg" },
      { name: "LinkedIn", icon: "https://upload.wikimedia.org/wikipedia/commons/c/ca/LinkedIn_logo_initials.png" },
      { name: "WordPress", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/wordpress/wordpress-plain.svg" },
      { name: "Salesforce", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/salesforce/salesforce-plain.svg" },
      { name: "Figma", icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg" }
    ]
  }
];

export const serviceStats = [
  { label: "Projects Completed", value: 150, suffix: "+", icon: "CheckCircle" },
  { label: "Happy Clients", value: 80, suffix: "+", icon: "Users" },
  { label: "Years Experience", value: 10, suffix: "+", icon: "Calendar" },
  { label: "Team Experts", value: 20, suffix: "+", icon: "Award" }
];

export const serviceFAQs = [
  {
    question: "How do you determine project costs?",
    answer: "We assess project complexity, features, and timeline to provide a transparent, detailed quotation with no hidden fees."
  },
  {
    question: "What is your typical project timeline?",
    answer: "Timelines vary by project. A basic website might take 2-4 weeks, while complex software solutions can take 2-4 months."
  },
  {
    question: "Do you provide support after launch?",
    answer: "Yes! We offer 3-6 months of free technical support and optional Annual Maintenance Contracts (AMC) for long-term care."
  },
  {
    question: "Can you help update my existing software?",
    answer: "Absolutely. We specialize in software modernization and can upgrade your legacy systems to the latest technologies."
  },
  {
    question: "How do you ensure data security and privacy?",
    answer: "We follow strict security protocols including data encryption, secure server configurations, and NDA (Non-Disclosure Agreements) to protect your intellectual property."
  },
  {
    question: "What technologies do you specialize in?",
    answer: "Our core stack includes React, Next.js for frontend, Python/Django, Node.js for backend, and AWS/Azure for cloud infrastructure."
  },
  {
    question: "Can I hire a dedicated team for my project?",
    answer: "Yes, we offer a 'Dedicated Team' engagement model where you get a full-time team of developers, designers, and PMs working exclusively for you."
  },
  {
    question: "How do you handle communication during the project?",
    answer: "We maintain transparent communication via weekly sprint meetings, real-time collaboration tools (like Slack/Teams), and regular progress reports."
  }
];

export const contactFAQs = [
  {
    question: " What is your typical response time?",
    answer: "We strive to respond to all inquiries within 2-4 business hours. For urgent support, our WhatsApp channel provides near-instant responses during business hours."
  },
  {
    question: "Do you sign NDAs?",
    answer: "Yes, we prioritize your intellectual property. We are happy to sign a Non-Disclosure Agreement (NDA) before discussing any sensitive project details."
  },
  {
    question: "Can we schedule a video call?",
    answer: "Absolutely! You can request a Zoom or Google Meet call via our contact form or WhatsApp to discuss your project in detail."
  },
  {
    question: "Do you work with international clients?",
    answer: "Yes, we work with clients globally. We are experienced in managing remote projects and adjusting to different time zones."
  }
];

export const industryFeatures = [
  {
    title: "Healthcare",
    description: "HIPAA-compliant telemedicine and practice management systems.",
    icon: "Heart"
  },
  {
    title: "Retail & E-commerce",
    description: "Omnichannel retail solutions with inventory and POS integration.",
    icon: "ShoppingCart"
  },
  {
    title: "Education",
    description: "LMS and student information systems for modern learning.",
    icon: "GraduationCap"
  },
  {
    title: "Real Estate",
    description: "Property management portals and virtual tour integrations.",
    icon: "Building"
  }
];
